import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

const SearchInput = ({ onChange, clearFilter, sx = {},value: externalValue, ...props}) => {
  const [value, setValue] = useState(externalValue || '');
  const handleChange = (event) => {
    const value = event?.target?.value;
    setValue(value);
    onChange(value);
  };

  useEffect(() => {
    setValue(externalValue || '');
  }, [externalValue]);

  useEffect(() => {
    if (clearFilter) {
      setValue('');
    }
  }, [clearFilter]);

  return (
    <TextField
      {...props}
      onChange={(e) => handleChange(e)}
      value={value}
      size="medium"
      sx={{ minWidth: '13.75rem', ...sx,}}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default SearchInput;
